<section class="authorization-denied">
   <label>{{"common.Access Denied" | translate}}</label>
   <img class="authorization-image" src="assets/images/access-denied-vd.jpg">
   <span class="messgae-bottom">{{"common.You do not have Sufficient Permission" | translate}}</span>
</section>